import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const adminConfigSettings = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/config-settings/index.js